import { render, staticRenderFns } from "./DataTime.vue?vue&type=template&id=0f5ccf7e&scoped=true&"
import script from "./DataTime.vue?vue&type=script&lang=js&"
export * from "./DataTime.vue?vue&type=script&lang=js&"
import style0 from "./DataTime.vue?vue&type=style&index=0&id=0f5ccf7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ccf7e",
  null
  
)

export default component.exports